import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { FireblockService } from '../fireblockvault/fireblockvault.service';
import { AddExchangeWithdrawal } from './addexchangewithdrawal/addexchangewithdrawal.component';
@Component({
    selector: 'app-exchangewithdrawal',
    templateUrl: './exchangewithdrawal.component.html',
    styleUrls: ['./exchangewithdrawal.component.css']
})
export class ExchangeWithdrawalComponent implements OnInit {
    displayedColumns = [
        'asset',
        'transferAmount',
        'amount',
        'fee',
        'exchange',
        'key',
        'address',
        'ref_id',
        'tx_id',
        'tx_hash',
        'note',
        'status',
        'exchange_time',
        'exchange_status',
        'createdAt'
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    public exchangeWithdrawDataSource: any = new MatTableDataSource();
    pageSize = 10;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private fireblock: FireblockService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.exchangeWithdrawDataSource.filter = filterValue;
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.fireblock.getExchangeWithdraw(this.filter).subscribe((success) => {
                let exchangeWithdrawRes = success.map(exchangeWithdraw => {
                    exchangeWithdraw.createdAt = moment(exchangeWithdraw.createdAt).format('MM/DD/YY h:mm:ss A');
                    exchangeWithdraw.exchange_time = moment(exchangeWithdraw.exchange_time * 1000).format('MM/DD/YY h:mm:ss A');
                    return exchangeWithdraw;
                })
                this.exchangeWithdrawDataSource = new MatTableDataSource(exchangeWithdrawRes);
                this.exchangeWithdrawDataSource.paginator = this.paginator
                this.exchangeWithdrawDataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.exchangeWithdrawDataSource.filteredData) {
            const exchangeWithdraw = await this.exchangeWithdrawDataSource.filteredData.map(x => ({
                Asset: x.asset,
                Amount: x.amount,
                Key: x.key,
                Exchange: x.exchange,
                Address: x.address,
                TransactionId: x.tx_id,
                RefId: x.ref_id,
                TransactionHash: x.tx_hash,
                Note: x.note,
                Status: x.status,
                Fee: x.fee,
                ExchangeStatus: x.exchange_status,
                createdAt: x.createdAt,
            }));
            TableUtil.exportArrayToExcel(exchangeWithdraw, "exchange-withdraw");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
    addExchangeWithdrawal = async () => {
        try {
            var new_element = {
                'exchange': '',
                'currency': "",
                'whitelist_address_key': '',
                'amount': "",
            }
            this.dialog.open(AddExchangeWithdrawal, {
                width: 'auto',
                data: new_element,
            }).afterClosed().subscribe(result => {
                if (result && result.success) {
                    this.applyRefreshData();
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/exchangewithdrawal/exchangewithdrawal.component.ts